"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolFilterDto = void 0;
const class_validator_1 = require("class-validator");
const shared_1 = require("../shared");
const class_transformer_1 = require("class-transformer");
class SchoolFilterDto extends shared_1.PaginationOptionsDto {
    constructor(schoolFilterOptions) {
        super();
        if (!schoolFilterOptions)
            return;
        this.id = schoolFilterOptions.id;
        this.name = schoolFilterOptions.name;
        this.schoolGroupName = schoolFilterOptions.schoolGroupName;
        this.currentAcademicYear = schoolFilterOptions.currentAcademicYear;
        this.schoolGroupId = schoolFilterOptions.schoolGroupId;
        this.schoolId = schoolFilterOptions.schoolId;
    }
    id;
    name;
    schoolGroupName;
    currentAcademicYear;
    schoolGroupId;
    schoolId;
    showAll;
}
exports.SchoolFilterDto = SchoolFilterDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SchoolFilterDto.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SchoolFilterDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SchoolFilterDto.prototype, "schoolGroupName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SchoolFilterDto.prototype, "currentAcademicYear", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SchoolFilterDto.prototype, "schoolGroupId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], SchoolFilterDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Boolean),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SchoolFilterDto.prototype, "showAll", void 0);
